import styled from '@emotion/styled';
import { theme } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { useTranslation } from 'react-i18next';

export const CancelReservationModalTitle = ({
  reservationInProgress,
}: {
  reservationInProgress: boolean;
}): JSX.Element => {
  const { t } = useTranslation('peopleProfileSidebar', {
    keyPrefix: 'bookings.cancelReservationModal',
  });
  const { token } = theme.useToken();

  return (
    <Title>
      <FontAwesomeIcon icon={faTriangleExclamation} color={token.colorError} />
      <span>
        {reservationInProgress
          ? t('end_desk_booking')
          : t('cancel_desk_booking')}
      </span>
    </Title>
  );
};

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
